import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BookOpen, ChevronRight } from "lucide-react";
import api from "@/lib/api";
import { SectionHeader } from "@/components/marketplace/SectionHeader";
import { LoadingState } from "@/components/common/States";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle,
} from "@/components/ui/dialog";

export default function Blog() {
  const [blogs, setBlogs] = useState(null);
  const [active, setActive] = useState(null);

  useEffect(() => {
    api.get("/blogs").then((r) => setBlogs(r.data));
  }, []);

  if (blogs === null) return <LoadingState />;
  const [feat, ...rest] = blogs;

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <SectionHeader eyebrow="Knowledge" title="Spiritual Blog & Guides" subtitle="Braj culture, pooja guides, festival tips and product care." />

      {feat && (
        <button onClick={() => setActive(feat)} className="w-full text-left grid md:grid-cols-2 gap-6 rounded-2xl overflow-hidden border border-border bg-card card-hover mb-10" data-testid={`blog-featured-${feat.slug}`}>
          <div className="aspect-[16/10] md:aspect-auto overflow-hidden bg-muted">
            <img src={feat.image} alt={feat.title} className="w-full h-full object-cover" />
          </div>
          <div className="p-6 sm:p-8 flex flex-col justify-center">
            <span className="eyebrow">{feat.category}</span>
            <h2 className="mt-2 text-2xl sm:text-3xl font-serif font-bold text-stone-900">{feat.title}</h2>
            <p className="mt-3 text-stone-600">{feat.excerpt}</p>
            <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-secondary">Read article <ChevronRight size={15} /></span>
          </div>
        </button>
      )}

      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
        {rest.map((b) => (
          <button key={b.slug} onClick={() => setActive(b)} data-testid={`blog-card-${b.slug}`} className="text-left rounded-xl overflow-hidden border border-border bg-card card-hover">
            <div className="aspect-[16/10] overflow-hidden bg-muted">
              <img src={b.image} alt={b.title} loading="lazy" className="w-full h-full object-cover" />
            </div>
            <div className="p-4">
              <span className="eyebrow text-[10px]">{b.category}</span>
              <h3 className="mt-1 font-serif font-semibold text-lg text-stone-900 leading-snug line-clamp-2">{b.title}</h3>
              <p className="mt-1 text-sm text-stone-500 line-clamp-2">{b.excerpt}</p>
            </div>
          </button>
        ))}
      </div>

      <Dialog open={!!active} onOpenChange={(o) => !o && setActive(null)}>
        <DialogContent className="max-w-2xl max-h-[85vh] overflow-auto">
          {active && (
            <>
              <div className="aspect-[16/9] -mx-6 -mt-6 mb-2 overflow-hidden bg-muted">
                <img src={active.image} alt={active.title} className="w-full h-full object-cover" />
              </div>
              <DialogHeader>
                <span className="eyebrow text-left">{active.category} • {active.date}</span>
                <DialogTitle className="font-serif text-2xl text-left">{active.title}</DialogTitle>
              </DialogHeader>
              <p className="text-stone-600 leading-relaxed">{active.content}</p>
              <p className="text-xs text-stone-400 flex items-center gap-1 mt-2"><BookOpen size={12} /> {active.author}</p>
            </>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
